// Copy Trading
const PATH_COPY_TRANDING = 'v1/copy-trading/';

// Automated Strategies
const PATH_AUTOMATED_STRATEGIES = 'v1/strategies';

// Auth
const PATH_CREATE_USER = 'v1/users';
const PATH_VERIFY_EMAIL = 'v1/users/verify-email';
const PATH_LOGIN = 'v1/login';
const PATH_LOGOUT = 'v1/logout';
const PATH_FORGOT_PASSWORD = 'v1/forget-password';
const PATH_RESET_PASSWORD = 'v1/reset-password/';
const PATH_TOKEN_VALID = 'v1/misc/access-token/validate';

// Brokers
const PATH_BROKERS = 'v1/brokers';

// Brokers
const PATH_COUNTRIES = 'v1/countries';

// Utility
const PATH_PORTFOLIO_SIZES = 'v1/portfolio-sizes';
const PATH_STATE_ABBR = 'v1/misc/state-abbr/';
const PATH_PROFILE_ICONS = 'v1/misc/profile-default-icons';

// Users
const PATH_USER_DETAILS = 'v1/users/';

// Subscriptions
const PATH_SUBSCRIPTIONS = 'v1/subscriptions/protected-routes/';
const PATH_STRATEGIES_SUB_PLANS = 'v1/subscription-plans/';

// Portfolios
const PATH_PORTFOLIOS = 'v1/portfolios/';

// Paypal
const PAYPAL_SANDBOX_BASE_URL = 'https://api-m.sandbox.paypal.com';
const PAYPAL_LIVE_BASE_URL = 'https://api-m.paypal.com';

// Signal Notifications
const PATH_SIGNAL_NOTIFICATIONS = 'v1/signal-notifications';

// No code builder
const { REACT_APP_API_NCB_BASE_URL: NCB_BASE_URL, REACT_APP_API_FINANCIAL_BASE_URL: FINANCIAL_BASE_URL } = process.env;

const PATH_BACKTESTING = `${NCB_BASE_URL}backtest`;
const PATH_BACKTESTING_PROCESS = `${NCB_BASE_URL}pid`;
const PATH_STRATEGY_PROFITABLE = `${NCB_BASE_URL}check`;
const PATH_PORTFOLIO_POSITIONS = `${NCB_BASE_URL}positions`;

const PATH_SEARCH_TARGET_ASSETS = `${FINANCIAL_BASE_URL}search`;
const PATH_TARGET_ASSETS_PRICE = `${FINANCIAL_BASE_URL}quote/`;
const PATH_TARGET_ASSETS_CHART = `${FINANCIAL_BASE_URL}/historical-price-full/`;

export {
  PATH_COPY_TRANDING,
  PATH_AUTOMATED_STRATEGIES,
  PATH_CREATE_USER,
  PATH_BROKERS,
  PATH_COUNTRIES,
  PATH_PORTFOLIO_SIZES,
  PATH_USER_DETAILS,
  PATH_VERIFY_EMAIL,
  PATH_STATE_ABBR,
  PATH_LOGIN,
  PATH_LOGOUT,
  PATH_FORGOT_PASSWORD,
  PATH_RESET_PASSWORD,
  PATH_SUBSCRIPTIONS,
  PATH_PORTFOLIOS,
  PATH_STRATEGIES_SUB_PLANS,
  PAYPAL_SANDBOX_BASE_URL,
  PAYPAL_LIVE_BASE_URL,
  PATH_SIGNAL_NOTIFICATIONS,
  PATH_BACKTESTING,
  PATH_BACKTESTING_PROCESS,
  PATH_SEARCH_TARGET_ASSETS,
  PATH_TARGET_ASSETS_PRICE,
  PATH_TARGET_ASSETS_CHART,
  PATH_PROFILE_ICONS,
  PATH_PORTFOLIO_POSITIONS,
  PATH_STRATEGY_PROFITABLE,
  FINANCIAL_BASE_URL,
  PATH_TOKEN_VALID,
};
